module.exports = __webpack_public_path__ + "static/img/hero.713d454.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero.svg
// module id = mmYe
// module chunks = 1